import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { Pageable } from '../../common/page/pageable.model';
import { loadMemberships } from '../../membership/store/membership.thunk';
import type { AppDispatch, RootState } from '../../store';
import { PerksHelper } from '../perks.helper';
import { loadPost, loadPostCounts, loadPosts, loadUser } from './perks.thunk';

export const perksListener = createListenerMiddleware();

/**
 * Listener 1: Load user and post counts after successfully load posts
 */
perksListener.startListening({
  matcher: isAnyOf(loadPosts.fulfilled),
  effect: async (_action, listenerApi) => {
    const dispatch = listenerApi.dispatch as AppDispatch;
    dispatch(loadUser());
    dispatch(loadPostCounts());
  },
});

/**
 * Listener 1b: Load post counts after successfully loading a single post, and the viewer if the
 * feed never loaded them. A post opened by direct link (or reloaded on its URL) skips the feed,
 * and without the viewer the comment moderation menu never renders -- not even on the viewer's
 * own comments (SNGL-7320).
 */
perksListener.startListening({
  matcher: isAnyOf(loadPost.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch as AppDispatch;
    dispatch(loadPostCounts(action.payload.id));
    const { user } = (listenerApi.getState() as RootState).perks;
    if (!user.loaded && !user.loading) {
      dispatch(loadUser());
    }
  },
});

/**
 * Listener 2: Reload posts after memberships are loaded
 *
 * This ensures posts access is updated after a user joins a membership
 */
perksListener.startListening({
  matcher: isAnyOf(loadMemberships.fulfilled),
  effect: async (_action, listenerApi) => {
    const state = listenerApi.getState() as RootState;
    const dispatch = listenerApi.dispatch as AppDispatch;

    // Only reload posts if they're already loaded (don't trigger on initial load)
    if (state.perks.posts.loaded) {
      console.log('[PerksListener] Reloading posts after memberships update');
      dispatch(
        loadPosts({
          pageable: Pageable.of(
            0,
            PerksHelper.POSTS_DEFAULT_PAGE_SIZE,
            PerksHelper.POSTS_DEFAULT_SORT
          ),
          filter: {},
        })
      );
    }
  },
});
